module.exports = __webpack_public_path__ + "static/lifewheel-purple-717f8c9c97b7548afab943139ecca25e.png";